import script from "./lotteryTimeSettings.vue?vue&type=script&setup=true&lang=js"
export * from "./lotteryTimeSettings.vue?vue&type=script&setup=true&lang=js"

import "./lotteryTimeSettings.vue?vue&type=style&index=0&id=47102420&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47102420"]])

export default __exports__